// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__kXDnj","leftPosition":"Tooltip_leftPosition__2E8Ul","noWrap":"Tooltip_noWrap__3s0Uo","error":"Tooltip_error__3OqMy"};